// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @ components
const HighLightedText = require('components/highLightedText/highLightedText');
// @ utilities
import { FormattedText } from 'core/i18n';

// @ constants
const { TIME_HORIZON_CHECK_ERROR, TIME_HORIZON_CHECK_WARNING } = require('constants/RAConstants');

class RATimeHorizonCheck extends React.Component {
    buildErrorMessage(date) {
        return (
            <div className="investment-plan__section-invest">
                <HighLightedText
                    className="form__hightlight-text form__hightlight-text--error"
                    icon={<i className="icons icons--icon-warning-red" />}
                >
                    <FormattedText value="raManagementPlan-raManagementPlan_errorMessage" injectedStrings={[date]} />
                </HighLightedText>
            </div>
        );
    }

    buildWarningMessage(date) {
        return (
            <div className="investment-plan__section-invest">
                <HighLightedText
                    className="form__hightlight-text form__hightlight-text--warning"
                    icon={
                        <div className="icon-container">
                            <i className="icons icons--icon-exclamation" />
                        </div>
                    }
                >
                    <FormattedText value="raManagementPlan-raManagementPlan_warningMessage" injectedStrings={[date]} />
                </HighLightedText>
            </div>
        );
    }

    render() {
        const { immTimeHorizonCheck } = this.props;
        const status = immTimeHorizonCheck.get('status');
        const date = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });

        if (status == TIME_HORIZON_CHECK_WARNING) {
            return this.buildWarningMessage(date);
        }
        if (status == TIME_HORIZON_CHECK_ERROR) {
            return this.buildErrorMessage(date);
        }

        return null;
    }
}

RATimeHorizonCheck.propTypes = {
    immTimeHorizonCheck: PropTypes.object.isRequired,
};

module.exports = connect(state => ({
    immTimeHorizonCheck: state.raTimeHorizonCheck,
}))(RATimeHorizonCheck);
